import { Template } from '@thro-types/notification';

import { z } from 'zod';

import { translations } from 'locales/i18n';
import { CreateTemplateVariable } from 'types/AppTypes';

export const initialMailTemplateValues = (initialTemplate?: Template): Partial<Template> => {
  return initialTemplate
    ? initialTemplate
    : {
        name: '',
        html: '',
        subject: '',
        text: '',
        variables: {}
      };
};

export const initialVariablesValues = (
  initialVariables?: CreateTemplateVariable
): CreateTemplateVariable => {
  return {
    key: '',
    description: '',
    scope: {
      html: false,
      subject: false,
      text: false
    }
  };
};

export const schema = (t: (key: string) => string) =>
  z.object({
    applicationsId: z.string(),
    name: z
      .string({
        error: t(translations.pages.articleMessagesSettings.validation.invalidString())
      })
      .min(1, {
        message: t(translations.pages.articleMessagesSettings.validation.invalidCharacterLength())
      }),
    description: z
      .string({
        error: t(translations.pages.articleMessagesSettings.validation.invalidString())
      })
      .min(1, {
        message: t(translations.pages.articleMessagesSettings.validation.invalidCharacterLength())
      }),
    html: z
      .string({
        error: t(translations.pages.articleMessagesSettings.validation.invalidString())
      })
      .min(1, {
        message: t(translations.pages.articleMessagesSettings.validation.invalidCharacterLength())
      }),
    subject: z
      .string({
        error: t(translations.pages.articleMessagesSettings.validation.invalidString())
      })
      .min(1, {
        message: t(translations.pages.articleMessagesSettings.validation.invalidCharacterLength())
      }),
    text: z.string(),
    variables: z
      .record(
        // variables is an object
        z
          .string()
          .regex(/^###.+###$/, {
            message: t(translations.pages.articleMessagesSettings.validation.invalidKey())
          })
          .min(1, {
            message: t(
              translations.pages.articleMessagesSettings.validation.invalidCharacterLength()
            )
          }),
        z.object({
          description: z.string().min(1, {
            message: t(
              translations.pages.articleMessagesSettings.validation.invalidCharacterLength()
            )
          }),
          scope: z.object({
            html: z.boolean(),
            text: z.boolean(),
            subject: z.boolean()
          })
        })
      )
      .default({})
  });

export type Schema = z.infer<ReturnType<typeof schema>>;
